import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBar } from '@angular/material/progress-bar'
import { SelectSearchModule } from 'src/components/select-search/select-search.module'
import { ModalModule } from 'src/shared/modal'
import { PipesModule } from 'src/shared/pipes/pipes.module'
import { ProductFormComponent } from './product-form.component'
import { ProductFormService } from './product-form.service'


@NgModule({
  declarations: [
    ProductFormComponent,
  ],
  providers: [ProductFormService],
  imports: [
    CommonModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatIconModule,
    ModalModule,
    SelectSearchModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    FlexLayoutModule,
    MatProgressBar,
  ],
})
export class ProductFormModule { }
